/** The periods a report can cover — the API's `REPORT_PERIODS`. */
export const REPORT_PERIOD_OPTIONS = [
  { value: '7', label: '7 days' },
  { value: '30', label: '30 days' },
  { value: '90', label: '90 days' },
] as const;

export type ReportPeriodOption = (typeof REPORT_PERIOD_OPTIONS)[number]['value'];

/**
 * How each console action reads on the report's timeline. An action not listed
 * here falls back to its code made readable, so a new one never shows blank.
 */
export const REPORT_EVENT_LABEL: Record<string, string> = {
  INSTITUTE_CREATED: 'Institute created',
  INSTITUTE_UPDATED: 'Details updated',
  INSTITUTE_ACTIVATED: 'Activated',
  INSTITUTE_SUSPENDED: 'Suspended',
  INSTITUTE_INVITE_SENT: 'Admin invite sent',
  INSTITUTE_EMAIL_SENT: 'Email sent to the admin',
  INSTITUTE_ADMIN_PASSWORD_SET: 'Admin password set by support',
  INSTITUTE_SETTINGS_UPDATED: 'Settings changed',
  SUBSCRIPTION_PAYMENT_RECORDED: 'Subscription payment recorded',
  INSTITUTE_FEATURE_TRACKED: 'Feature added',
  INSTITUTE_FEATURE_WITHDRAWN: 'Feature removed',
  INSTITUTE_FEATURE_UPDATED: 'Feature status changed',
};
